import { Button, Popover, Space, Table, message } from "antd";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router";
import DeleteButton from "../UI/DeleteButton/deletebutton";
import type { ColumnsType } from "antd/es/table";
import PrintButton from "../UI/PrintButton/printbutton";
import DeleteModal from "../UI/ModalComponent/DeleteModal/deletemodal";
import { UseMutateAsyncFunction, useMutation, useQuery } from "react-query";
import { AxiosResponse } from "axios";
import {
  deletePayments,
  getCustomersReceipts,
  getPaymentsById,
  getSalesDropdown,
} from "../../api/receipts";
import { getPaymentModesDropdown } from "../../api/paymentMode";
import { getCurrencyDropdown } from "../../api/currency";
import { EditOutlined } from "@ant-design/icons";
import { format } from "date-fns";
interface Props {
  payments: any;
  isPaymentsLoading: boolean;
  setPage: Dispatch<SetStateAction<number>>;
  selectedCustomer: null;
  page: number;
  setPayments: Dispatch<any>;
  getCustomerPaymentsMutation: UseMutateAsyncFunction<
    AxiosResponse<any, any>,
    unknown,
    void,
    unknown
  >;
  tableKey: number;
}

interface ReceiptsInterface {
  id: string;
  invoiceNo: string;
  rate: string;
  amount: number;
  customer: number;
  paymentMode: number;
  date: string;
}

export const CustomerPaymentList = ({
  payments,
  isPaymentsLoading,
  selectedCustomer,
  setPage,
  page,
  setPayments,
  getCustomerPaymentsMutation,
  tableKey,
}: Props) => {
  const [t] = useTranslation("common");
  const navigate = useNavigate();
  const { state } = useLocation();
  const [open, setOpen] = useState(false);
  const [idToDelete, setIdToDelete] = useState<string | undefined>(undefined);
  const [formatedPaymentMode, setFormatedPaymentMode] = useState<{}[]>();
  const [formatedCurrency, setFormatedCurrency] = useState<{}[]>();
  const [nameToDelete, setNameToDelete] = useState<any>();
  const [prevPage, setPrevPage] = useState<number>(0);
  const [maxPage, setMaxPage] = useState<number>(0);
  const [formatedsales, setFormatedSales] = useState<any>([]);

  const [receiptById, setReceiptById] = useState<any>();
  useEffect(() => {
    page > prevPage &&
      maxPage < page &&
      getCustomerPaymentsMutation().then((res: any) => {
        if (page > maxPage) setMaxPage(page);

        setPayments(res.data?.data);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);

  const deletePaymentsMutation = useMutation("deletePayments", deletePayments, {
    onSuccess: () => {
      getCustomerPaymentsMutation().then((res: any) => {
        setPayments(res.data?.data);
        message.success("Complete successfully");
      });
    },
  });
  const { mutateAsync: payemntByIdMutation, isLoading: isSaleByIdLoading } =
    useMutation("sale", () => getPaymentsById(state.id), {
      onSuccess: (res) => setReceiptById([res?.data]),
    });

  useEffect(() => {
    state && payemntByIdMutation();
  }, []);

  const DeleteCustomerPayment = (
    id: string | undefined,
    customer: string
  ): void => {
    setOpen(true);
    setIdToDelete(id);
    setNameToDelete(customer);
  };

  const handleOk = () => {
    if (idToDelete) {
      deletePaymentsMutation.mutate({ id: idToDelete });
    }
    setOpen(false);
  };

  const getPaymentMutation = useMutation("getPayments", getPaymentsById);

  function fillPaymentsById(id: any) {
    getPaymentMutation.mutateAsync(id).then((res) => {
      navigate(`/customerpayment/${id}`, {
        state: {
          Payment: res.data,
          formatedCurrency: formatedCurrency,
          loadingCurrency: loadingCurrency,
          formatedPaymentMode: formatedPaymentMode,
          loadingPaymentMode: loadingPaymentMode,
          isSalesLoading: isSalesLoading,
          formatedsales: formatedsales,
        },
      });
    });
  }

  const { isLoading: loadingCurrency } = useQuery(
    "currencies",
    getCurrencyDropdown,
    {
      refetchOnWindowFocus: false,
      onSuccess: (res) => {
        setFormatedCurrency(
          res.data?.map((curr: any) => {
            return { value: curr.id, label: curr.name };
          })
        );
      },
    }
  );

  const { isLoading: loadingPaymentMode } = useQuery(
    "paymentmode",
    getPaymentModesDropdown,
    {
      refetchOnWindowFocus: false,
      onSuccess: (res) => {
        setFormatedPaymentMode(
          res.data?.map((payment: any) => {
            return { value: payment.id, label: payment.mode };
          })
        );
      },
    }
  );

  const { isLoading: isSalesLoading } = useMutation(
    "getSales",
    (customerId: number) => getSalesDropdown(customerId),
    {
      onSuccess: (result) => {
        setFormatedSales(
          result?.data.map((bill: any) => {
            return { value: bill.id, label: bill.invoiceNo };
          })
        );
      },
    }
  );
  const [filteredItems, setFilteredItems] = useState([]);
  const [isFiltering, setIsFiltering] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsFiltering(true); // Set loading state for filtering
        if (selectedCustomer) {
          const response = await getCustomersReceipts(selectedCustomer);
          setFilteredItems(response.data.data);
        } else {
          setFilteredItems(payments);
        }
      } catch (error) {
        console.error("Error fetching items:", error);
      } finally {
        setIsFiltering(false); // Clear loading state for filtering
      }
    };

    fetchData();
  }, [payments, selectedCustomer]);
  const [isEditing, setIsEditing] = useState(false);
  const content = <div>{t("edit")}</div>;
  const columns: ColumnsType<ReceiptsInterface> = [
    {
      title: `${t("customer")}`,
      dataIndex: "pSale",
      key: "customer",
      className: "table-header",
      render: (record: any) => {
        return <>{record ? record.customer?.name : null}</>;
      },
    },
    {
      title: `${t("payment-mode")}`,
      dataIndex: "paymentMode",
      key: "paymentMode",
      width: "12rem",
      render: (record: any) => {
        return record ? record.mode : null;
      },
    },
    {
      title: `${t("sales-number")}`,
      dataIndex: "pSale",
      key: "number",
      width: "9rem",
      render: (record: any) => {
        return <>{record.invoiceNo}</>;
      },
    },
    {
      title: `${t("date")}`,
      dataIndex: "date",
      key: "date",
      width: "10rem",
      render: (date: any) => {
        return format(new Date(date), "MM/dd/yyyy HH:mm");
      },
    },
    {
      title: `${t("amount")}`,
      dataIndex: "amountText",
      key: "amountText",
      width: "12rem",
    },
    {
      title: `${t("rate")}`,
      dataIndex: "exchangeRateText",
      key: "exchangeRateText",
      width: "4rem",
    },
    {
      title: `${t("action")}`,
      key: "action",
      align: "center",
      width: "7rem",
      fixed: "right",
      render: (record: any) => (
        <>
          <PrintButton onClick={() => console.log("hh")} />
          <Popover content={content} mouseEnterDelay={0} mouseLeaveDelay={0}>
            <Button
              className="Button"
              type="text"
              icon={
                <EditOutlined style={{ color: "#212121", fontSize: "14px" }} />
              }
              onClick={() => {
                if (!isEditing) {
                  setIsEditing(true);
                  fillPaymentsById(record.id);
                }
              }}
              size={"small"}
              disabled={isEditing || record.pSale.isPaid}
            />
          </Popover>
          <DeleteButton
            onClick={() => DeleteCustomerPayment(record?.id, record?.customer)}
          />
        </>
      ),
    },
  ];
  return (
    <>
      <DeleteModal
        open={open}
        setOpen={setOpen}
        name={nameToDelete}
        onOk={handleOk}
      />
      <Table
        key={tableKey}
        loading={isFiltering || isPaymentsLoading}
        scroll={{ x: 1000 }}
        columns={columns}
        dataSource={selectedCustomer ? filteredItems : payments}
        rowClassName={(record, index) =>
          index % 2 === 0
            ? "table-row-light table-row"
            : "table-row-dark table-row"
        }
        onChange={(selectedPage) => {
          setPrevPage(page);
          setPage(selectedPage?.current ?? 1);
        }}
        rowKey={(record) => record.id}
      />
    </>
  );
};
